"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var Close_1 = require("@material-ui/icons/Close");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var termsAndConditionsModalStyles_1 = require("./termsAndConditionsModalStyles");
var TermsAndConditionsModal = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen, setIsAccepted = _a.setIsAccepted;
    var styles = termsAndConditionsModalStyles_1.default();
    var handleAccept = react_1.useCallback(function () {
        setIsAccepted(true);
        setIsOpen(false);
    }, [setIsAccepted, setIsOpen]);
    return (<core_1.Dialog open={isOpen} className={styles.dialog} classes={{
        paper: styles.dialogPaper,
    }} data-test={'checkout:identityVerification:terms:modal'}>
      <core_1.DialogTitle className={styles.dialogTitle}>
        <core_1.Box className={styles.dialogTitleContent}>
          <core_1.Typography variant={'h4'}>
            <Translation_1.default id={'trans__insurance__insapp_scan_singpass__modal_title_label'}/>
          </core_1.Typography>
          <core_1.IconButton className={styles.iconButton} onClick={function () { return setIsOpen(false); }} data-test={'checkout:identityVerification:terms:modal:close'}>
            <Close_1.default />
          </core_1.IconButton>
        </core_1.Box>
      </core_1.DialogTitle>
      <core_1.DialogContent className={styles.dialogContent}>
        <core_1.Typography className={styles.disclaimerText}>
          <Translation_1.default id={'trans__checkout__next_step__customer_information__singpass_disclaimer1'}/>
        </core_1.Typography>
        <core_1.Typography className={styles.disclaimerText}>
          <Translation_1.default id={'trans__checkout__next_step__customer_information__singpass_disclaimer2'}/>
        </core_1.Typography>
        <core_1.Typography className={styles.disclaimerText}>
          <Translation_1.default id={'trans__checkout__next_step__customer_information__singpass_disclaimer3'}/>
        </core_1.Typography>
      </core_1.DialogContent>
      <core_1.DialogActions className={styles.dialogActions}>
        <core_1.Button color="primary" variant="contained" className={styles.acceptButton} onClick={handleAccept} data-test={'checkout:identityVerification:terms:modal:accept'}>
          <core_1.Typography variant={'caption'}>
            <Translation_1.default id={'trans__insurance__insapp_scan_singpass__modal_cta_label'}/>
          </core_1.Typography>
        </core_1.Button>
      </core_1.DialogActions>
    </core_1.Dialog>);
};
exports.default = TermsAndConditionsModal;
